const DEPARTMENT_COUNT_FILTER_TYPE = {
    typeAll: 'ALL',
    typeNone: 'NONE',
    typeOne: 'ONE',
    typeMore: 'MORE'
}

export default DEPARTMENT_COUNT_FILTER_TYPE